import React from 'react'
import { useLocalStorage } from 'usehooks-ts'

export type LLMConfig = {
  provider: 'openai' | 'anthropic' | 'google' | 'openrouter' | ''
  model: string
  apiKey: string
}

const DEFAULT_CONFIG = {
  provider: '',
  model: '',
  apiKey: '',
} as LLMConfig

export const useConfig = () => {
  const [config, setConfig] = useLocalStorage(
    'resume-alpha-config',
    DEFAULT_CONFIG,
  )

  const isConfigured = React.useMemo(() => {
    return (
      config.provider?.length >= 0 &&
      config.model?.length > 0 &&
      config.apiKey?.length > 0
    )
  }, [config])

  const handleClear = React.useCallback(() => {
    setConfig(DEFAULT_CONFIG)
  }, [])

  return { config, setConfig, isConfigured, handleClear }
}
